// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"10fa8590","239":"f8784c15","453":"4dd268a6","667":"5fbf18c5"}[chunkId] + ".chunk.js";
};